import client from "./clients/portalClient";

const getAllUsers = () => client.get(`/users`);
const getSingleUser = (id) => client.get(`/users/${id}`);
// de ID is "auth0|1", "auth0|29" etc
const editSingleUser = (id, data) => client.post(`/users`, id, data);
const editSingleUserPerms = (id, data) => client.put(`/users/${id}`, data);
const postNewUser = (data) => client.post(`/users`, data);
const getUsersByRole = (role) => client.get(`/users?role=${role}`);
const getWeekstaten = () => client.get("/timesheet/dashboard")



const getUserBudgetYearData = (id) => client.get(`/users/${id}/productivity`);
const postUserBudgetData = (data) => client.post(`/productivity_details`, data);
const deleteUserEditYearData = (id) => client.delete(`/productivity_details/${id}`);
const editUserEditYearData = (id, data) => client.put(`/productivity_details/${id}`, data);

const adminUsersApi = {
  getAllUsers,
  getSingleUser,
  editSingleUser,
  editSingleUserPerms,
  postNewUser,
  getUsersByRole,
  getWeekstaten,
  postUserBudgetData,
  getUserBudgetYearData,
  deleteUserEditYearData,
  editUserEditYearData
};

export default adminUsersApi;
